import SpoilerEditorWrapper from "./Components/Wrappers/SpoilerEditorWrapper";
import { DEFAULTS } from "./defaults";
import { tiptapExtensions } from "./tiptap/tiptap";
import { SPOILER_TYPE } from "./types";
import { getTextButtons } from "./getTextButtons";
import { spoilerConverter } from "./spoiler-converter";
const pluginSpoiler = (config) => {
  const pluginConfig = { ...DEFAULTS.config, SpoilerEditorWrapper, ...config };
  return {
    config: pluginConfig,
    pmNodeConverters: [],
    pmMarkConverters: [spoilerConverter],
    type: SPOILER_TYPE,
    tiptapExtensions,
    textButtons: getTextButtons()
  };
};
export {
  SpoilerEditorWrapper,
  pluginSpoiler
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
